import React, { useContext, useState, useEffect } from 'react'
import {
    Button, Alert, TextField, Dialog, DialogActions,
    DialogContent, CircularProgress
} from '@mui/material';
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useTranslation } from 'react-i18next';
import { getOffer } from '../../API/offerAPI'
import { countRequest } from '../../API/resultAPI'
import { Context } from '../../AppContext';

import './ModalComponent.scss'
import {ResultBlock} from "../index";

const ModalComponent = ({
    codeFrom, codeTo, totalKg,
    totalVolume, valueFrom, valueTo, modalTitle, totalPlaces }) => {
    const lang = localStorage.getItem('i18nextLng')

    const [visibleForm, setVisibleForm] = useState(true)
    const { t } = useTranslation()
    const { inputFields,
        totalCount, setOpenModal, openModal,
        takeOfSender, delivery, insurance,
        setSuccess, setError, success, error,
        setTotalCount, setValueFrom,
        setValueTo, setInputFields,
        setDelivery, setInsurance,
        setCodeFrom, setCodeTo, setModalTitle, loading, setLoading
    } = useContext(Context)

    const schema = yup.object().shape({
        email: yup.string().email(`${t('warning.wrong_mail')}`).required(`${t("warning.еnter_mail")}`),
        phone: yup.string().required(`${t("warning.phone")}`),
    })
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "onBlur",
        resolver: yupResolver(schema)
    })

    useEffect(()=>{
        if (error) { setVisibleForm(false) }
    }, [error])

    const handleClose = () => {
        setOpenModal(false)
        setVisibleForm(false)
        setSuccess(false)
        setError(false)
        setTotalCount(null)
        setValueFrom("")
        setValueTo("")
        setInputFields([{
            length: '',
            width: '',
            height: '',
            weight: '',
            seats: ''
        }])
        setDelivery(false)
        setInsurance(false)
        setCodeFrom(null)
        setCodeTo(null)
        setModalTitle(null)
    }

    const openForm = () => setVisibleForm(true)

    const onSubmit = async (formData) => {
        const data = {
            countryCodeFrom: codeFrom ? codeFrom?.country_code : "",
            postCodeFrom: codeFrom ? Number(codeFrom?.post_code?.slice(0, 2)) : "",
            postCodeTo: codeTo ? Number(codeTo?.post_code?.slice(0, 3)) : "",
            cityFrom: valueFrom,
            cityTo: valueTo,
            totalKg: totalKg,
            totalVolume: totalVolume,
            totalPrice: totalCount,
            totalPlaces: totalPlaces,
            customerName: formData.name,
            customerEmail: formData.email ? formData.email : "",
            customerPhone: formData.phone ? formData.phone : "",
            cargoPlaces: inputFields,
            takeOfSender: takeOfSender,
            delivery: delivery,
            insurance: insurance,
            locale: lang
        }
        try {
            await getOffer(data)
            setSuccess(true)
        } catch (e) {
            setError(true)
        }
    }

    const retryRequest = async () => {
        setLoading(true)
        const data = {
            countryCodeFrom: codeFrom ? codeFrom?.country_code : "",
            postCodeFrom: (codeFrom && codeFrom.post_code) ? Number(codeFrom?.post_code?.slice(0, 2)) : "",
            postCodeTo: codeTo ? Number(codeTo.post_code) : "",
            cityFrom: valueFrom,
            cityTo: valueTo,
            totalKg: totalKg,
            totalVolume: totalVolume,
            locale: lang
        }
        try {
            const result = await countRequest(data, lang)
            setLoading(false)
            setError(false)
            setVisibleForm(true)
            setTotalCount(result)
            setModalTitle(result)
        } catch (e) {
            setLoading(false)
            if(e.message.split(" ").pop() !== '400') {
                setError(true)
                setVisibleForm(false)
            } else {
                setVisibleForm(true)
                setError(false)
                setVisibleForm(true)
            }

        }
    }

    const SuccessOffer = () => {
        return (
            <div className="success-offer">
                {success && <Alert severity="success">
                    {t('warning.success')}
                </Alert>
                }
                <div className="success-offer_button">
                    <button
                        onClick={handleClose}
                        className="calculate-block__btn sm">
                        {t("button.off")}
                    </button>
                </div>
            </div>
        )
    }

    const header = () => {
        if (modalTitle === t("warning.individually_offer")) {
            return modalTitle
        } else {
            return <p> {t('warning.contact_offer')} </p>
        }
    }

    return (
        <Dialog open={openModal}
            className="modal-form"
            onClose={handleClose}>
            <DialogContent>
                <ResultBlock
                  valueFrom={valueFrom}
                  valueTo={valueTo}
                  totalVolume={totalVolume}
                  totalKg={totalKg}
                  totalPlaces={totalPlaces}
                  codeFrom={codeFrom}
                />
                <h4 align={'center'}>{error ? '' : header()}</h4>
                {success ? <SuccessOffer /> :
                    visibleForm && (
                        <form
                            onSubmit={handleSubmit(onSubmit)}>
                            <TextField
                                name="email"
                                margin="normal"
                                label="Email"
                                type="email"
                                fullWidth
                                variant="outlined"
                                error={!!errors.email}
                                helperText={errors.email?.message}
                                {...register('email')}
                            />
                            <TextField
                                margin="normal"
                                label={t("full_name")}
                                type="text"
                                fullWidth
                                variant="outlined"
                                {...register('name')}
                            />
                            <TextField
                                name="phone"
                                margin="normal"
                                label={t("phone")}
                                type="text"
                                fullWidth
                                variant="outlined"
                                error={!!errors.phone}
                                helperText={errors.phone?.message}
                                {...register('phone')}
                            />
                            <DialogActions>
                                <button
                                    onClick={handleClose}
                                    className="calculate-block__btn sm">
                                    {t("button.cancel")}
                                </button>
                                <button
                                    type="submit"
                                    className="calculate-block__btn sm">

                                    {t("button.send")}
                                </button>
                            </DialogActions>
                        </form>
                    )
                }

            {!visibleForm && (
                  <div className="success-offer_button">
                      <button
                        disabled={loading}
                        onClick={() => retryRequest()}
                        className="calculate-block__btn sm">
                          {loading ?
                            <CircularProgress size={30} sx={{ color: 'white' }} /> :
                            t("button.retry")
                          }
                      </button>
                  </div>
            )}

            </DialogContent>
            {error && <Alert severity="error">
                {t('warning.error')}
            </Alert>}
        </Dialog>
    )
}

export default ModalComponent
